import styled from 'styled-components';

export const Suggestion = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const SuggestionName = styled.p`
  font-size: 14px;
  line-height: 21px;
  font-weight: 600;
  color: ${(props) => props.theme.colors['neutral-100']};
  margin-left: -7px;
  text-align: left;
`;
